import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/bot.png';
const _hoisted_1 = {
    class: "chat-bot-iframe"
};
const _hoisted_2 = [
    "src"
];
import useAppStore from '@/store/modules/app.ts';
import { onMounted, ref } from 'vue';
import { getAiTicket } from '@/api/common.ts';
import { useRouter } from 'vue-router';
import { checkLoginAndRedirect } from '@/utils/checkLoginAndRedirect.ts';
import { useDingTalk } from '@/hooks/useDingTalk.ts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatBot',
    setup (__props) {
        var _router_currentRoute_value, _router_currentRoute;
        const router = useRouter();
        const { handleCustomService } = useDingTalk();
        const { appConfig } = useAppStore();
        const iframeSrc = ref('');
        const showChatBot = ref(false);
        const fullPath = (router === null || router === void 0 ? void 0 : (_router_currentRoute = router.currentRoute) === null || _router_currentRoute === void 0 ? void 0 : (_router_currentRoute_value = _router_currentRoute.value) === null || _router_currentRoute_value === void 0 ? void 0 : _router_currentRoute_value.fullPath) || '/';
        const toggleChatBot = ()=>{
            checkLoginAndRedirect({
                path: fullPath,
                callback: ()=>{
                    showChatBot.value = !showChatBot.value;
                    if (iframeSrc.value) return;
                    getAiTicket().then((res)=>{
                        iframeSrc.value = `${appConfig['aihub_domain']}spacebot/${appConfig['aihub_customer_service']}?token=${res.data}`;
                    });
                }
            });
        };
        const handleMessage = (e)=>{
            if (e.data === 'close') {
                showChatBot.value = false;
            }
            if (e.data === 'customService') {
                handleCustomService();
            }
        };
        onMounted(()=>{
            window.addEventListener('message', handleMessage);
        });
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "chat-bot-container",
                    onClick: toggleChatBot
                }, [
                    ..._cache[0] || (_cache[0] = [
                        _createElementVNode("img", {
                            class: "chat-bot-img",
                            src: _imports_0,
                            alt: "智能助手"
                        }, null, -1),
                        _createElementVNode("span", null, "客服", -1)
                    ])
                ]),
                (_openBlock(), _createBlock(_Teleport, {
                    to: "body"
                }, [
                    _createVNode(_Transition, {
                        name: "float-chat-fade"
                    }, {
                        default: _withCtx(()=>[
                                _withDirectives(_createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("iframe", {
                                        src: iframeSrc.value,
                                        style: {
                                            "width": "100%",
                                            "height": "100%",
                                            "border": "none"
                                        }
                                    }, null, 8, _hoisted_2)
                                ], 512), [
                                    [
                                        _vShow,
                                        iframeSrc.value && showChatBot.value
                                    ]
                                ])
                            ]),
                        _: 1
                    })
                ]))
            ], 64);
        };
    }
});
